export default "__VITE_ASSET__DXLdqKoH__"